export default "__VITE_ASSET__ced9673c__"